/* tslint:disable */
/* eslint-disable */
/**
 * EstateEngine.Core.Api - All endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ExternalIntegrationResponse,
  ExternalIntegrationResponsePagedData,
  FacebookCreateRequest,
} from '../models';
import {
    ExternalIntegrationResponseFromJSON,
    ExternalIntegrationResponseToJSON,
    ExternalIntegrationResponsePagedDataFromJSON,
    ExternalIntegrationResponsePagedDataToJSON,
    FacebookCreateRequestFromJSON,
    FacebookCreateRequestToJSON,
} from '../models';

export interface ExternalIntegrationsFacebookPostRequest {
    facebookCreateRequest?: FacebookCreateRequest;
}

export interface ExternalIntegrationsGetRequest {
    pageNumber?: number;
    size?: number;
    orderByProperty?: string;
    ascending?: boolean;
    searchTerm?: string;
}

export interface ExternalIntegrationsIdDeleteRequest {
    id: string;
}

export interface ExternalIntegrationsIdGetRequest {
    id: string;
}

/**
 * 
 */
export class ExternalIntegrationsApi extends runtime.BaseAPI {

    /**
     */
    async externalIntegrationsFacebookPageNameGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ExternalIntegrations/Facebook/PageName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async externalIntegrationsFacebookPageNameGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.externalIntegrationsFacebookPageNameGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async externalIntegrationsFacebookPostRaw(requestParameters: ExternalIntegrationsFacebookPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalIntegrationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ExternalIntegrations/Facebook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FacebookCreateRequestToJSON(requestParameters.facebookCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalIntegrationResponseFromJSON(jsonValue));
    }

    /**
     */
    async externalIntegrationsFacebookPost(requestParameters: ExternalIntegrationsFacebookPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalIntegrationResponse> {
        const response = await this.externalIntegrationsFacebookPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async externalIntegrationsGetRaw(requestParameters: ExternalIntegrationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalIntegrationResponsePagedData>> {
        const queryParameters: any = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.orderByProperty !== undefined) {
            queryParameters['orderByProperty'] = requestParameters.orderByProperty;
        }

        if (requestParameters.ascending !== undefined) {
            queryParameters['ascending'] = requestParameters.ascending;
        }

        if (requestParameters.searchTerm !== undefined) {
            queryParameters['searchTerm'] = requestParameters.searchTerm;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ExternalIntegrations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalIntegrationResponsePagedDataFromJSON(jsonValue));
    }

    /**
     */
    async externalIntegrationsGet(requestParameters: ExternalIntegrationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalIntegrationResponsePagedData> {
        const response = await this.externalIntegrationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async externalIntegrationsIdDeleteRaw(requestParameters: ExternalIntegrationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalIntegrationResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling externalIntegrationsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ExternalIntegrations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalIntegrationResponseFromJSON(jsonValue));
    }

    /**
     */
    async externalIntegrationsIdDelete(requestParameters: ExternalIntegrationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalIntegrationResponse> {
        const response = await this.externalIntegrationsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async externalIntegrationsIdGetRaw(requestParameters: ExternalIntegrationsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalIntegrationResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling externalIntegrationsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ExternalIntegrations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalIntegrationResponseFromJSON(jsonValue));
    }

    /**
     */
    async externalIntegrationsIdGet(requestParameters: ExternalIntegrationsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalIntegrationResponse> {
        const response = await this.externalIntegrationsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
